import { render, staticRenderFns } from "./inventoryDetails.vue?vue&type=template&id=278605e2&scoped=true"
import script from "./inventoryDetails.vue?vue&type=script&lang=js"
export * from "./inventoryDetails.vue?vue&type=script&lang=js"
import style0 from "./inventoryDetails.vue?vue&type=style&index=0&id=278605e2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278605e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('278605e2')) {
      api.createRecord('278605e2', component.options)
    } else {
      api.reload('278605e2', component.options)
    }
    module.hot.accept("./inventoryDetails.vue?vue&type=template&id=278605e2&scoped=true", function () {
      api.rerender('278605e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/order_manage/inventory_statistics/form/inventoryDetails.vue"
export default component.exports